export default __webpack_public_path__ + "static/media/blockchain-icon.8af0211e.svg";